import { mount } from '../dom-lifecycle';

class Validator {
	static clearErrors = (input) => {
		$(input).closest(".form-file").find(".form-file-feedbacks .invalid-feedback").hide();
	}
	static showError = (input, errors) => {
		let message = null;
		errors.forEach((error) => {
			switch (error) {
				case "size":
					message = ".invalid-feedback-size";
					break;
				case "type":
					message = ".invalid-feedback-type";
					break;
			}
			$(input).closest(".form-file").find(message).show();
		});
	}
	static removeFile = (input, preview, previewDefault) => {
		$(input).closest(".form-file").find(".btn-remove").hide();
		$(input).closest(".form-file").find('.file-name').text("");
		$(preview).prop("src", previewDefault);
		$(preview).removeClass("has-file");
	}
	static attachFile = (file, input, preview) => {
		const reader = new FileReader();
		reader.onload = (event) => {
			if (file.type.includes("image")) {
				$(preview).prop("src", event.target.result);
				$(preview).addClass("has-file");
			} else {
				$(preview).prop("src", $(preview).data("src"));
				$(preview).removeClass("has-file");
			}
		};
		reader.readAsDataURL(file);
		$(input).closest(".form-file").find('.file-name').text(file.name);
		$(input).closest(".form-file").find(".form-file-feedbacks .invalid-feedback").hide();
		$(input).closest(".form-file").find(".btn-remove").show();
	}
}

mount(".form-file", file => {
	const input = file.querySelector("input[type=file]");
	const buttonRemove = file.querySelector(".btn-remove");
	const preview = {
		element: file.querySelector("img.form-file-preview"),
		default: file.querySelector("img.form-file-preview").src,
	}
	const rules = {
		size: $(input).data("max-size"),
		type: $(input).attr("accept"),
	}

	if (rules.type) {
		const typeError = file.querySelector(".file-type-error");
		if (typeError) typeError.innerText = `${rules.type}`;
	}
	if (rules.size) {
		const sizeError = file.querySelector(".file-size-error");
		if (sizeError) sizeError.innerText = `${rules.size} MB`;
	}

	$(buttonRemove).on('click', function() {
		$(input).val("").trigger("change");
	});

	$(input).on("change", (event) => {
		Validator.clearErrors(input);
		Validator.removeFile(input, preview.element, preview.default);
		let file = event.target.files[0];
		if (file) {
			const errors = [];
			if (file.size > rules.size * 1024 * 1024) {
				errors.push("size");
				$(input).val("").trigger("change");
			}
			if (rules.type && !rules.type.includes(file.name.split('.').pop().toLowerCase())) {
				errors.push("type");
				$(input).val("").trigger("change");
			}
			if (errors.length > 0) {
				Validator.showError(input, errors);
			} else {
				Validator.attachFile(file, input, preview.element);
			}
		}
	});

	$(input.form).on('reset', () => {
		Validator.clearErrors(input);
		Validator.removeFile(input, preview.element, preview.default);
	});
});